/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DynamicMappingsInputMappedValue
 */
export interface DynamicMappingsInputMappedValue {
    /**
     * 
     * @type {string}
     * @memberof DynamicMappingsInputMappedValue
     */
    mappedValue: string;
    /**
     * 
     * @type {string}
     * @memberof DynamicMappingsInputMappedValue
     */
    mappedDisplayValue: string;
}

/**
 * Check if a given object implements the DynamicMappingsInputMappedValue interface.
 */
export function instanceOfDynamicMappingsInputMappedValue(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mappedValue" in value;
    isInstance = isInstance && "mappedDisplayValue" in value;

    return isInstance;
}

export function DynamicMappingsInputMappedValueFromJSON(json: any): DynamicMappingsInputMappedValue {
    return DynamicMappingsInputMappedValueFromJSONTyped(json, false);
}

export function DynamicMappingsInputMappedValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): DynamicMappingsInputMappedValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mappedValue': json['mappedValue'],
        'mappedDisplayValue': json['mappedDisplayValue'],
    };
}

export function DynamicMappingsInputMappedValueToJSON(value?: DynamicMappingsInputMappedValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mappedValue': value.mappedValue,
        'mappedDisplayValue': value.mappedDisplayValue,
    };
}

